import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import HelperText from './HelperText'
import { getProps } from './utils'

import {
  FormFieldProps,
} from '../../../../types/frontend/form'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    marginTop: theme.spacing(2),
  },
}))

const RadioField: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {

  const {
    field: {
      name,
      value,
      onChange,
    },
    disabled,
    error,
    touched,
    item,
    readonly,
  } = getProps(props)

  const classes = useStyles()
  const title = item.title || name

  return (
    <FormControl component="fieldset" className={ classes.root } disabled={ disabled }>
      <FormLabel component="legend">{ title }</FormLabel>
      <RadioGroup
        aria-label={ title }
        name={ name }
        value={ value }
        onChange={ onChange }
        row={ item.meta && item.meta.row ? true : false }
      >
        {
          (item.options || []).map((option, i) => {
            option = typeof(option) === 'string' ? {
              title: option,
              value: option,
            } : option

            return (
              <FormControlLabel
                key={ i }
                value={ option.value }
                label={ option.title }
                disabled={ readonly || disabled }
                control={<Radio disabled={ readonly } />}
              />
            )
          })
        }
      </RadioGroup>
      <HelperText
        helperText={ item.helperText }
        error={ error ? true : false }
        touched={ touched }
      />
    </FormControl>
  )
}

export default RadioField